var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "eb849f0805c061116027b61471d0891be29f88c8"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "eb849f0805c061116027b61471d0891be29f88c8"
};